import { Alert, Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { Trans, useTranslation } from 'react-i18next';

type RemoveOrganisationDialogProps = {
  open: boolean;
  organisationText: string;
  onClose: () => void;
  onSubmit: () => void;
};

const RemoveOrganisationDialog = ({
  open,
  organisationText,
  onClose,
  onSubmit,
}: RemoveOrganisationDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      dialogProps={{
        sx: {
          '& > div > div': {
            maxWidth: '360px !important',
          },
          '& > div > div > h2': {
            paddingTop: '0',
            paddingBottom: '0',
          },
        },
      }}
      primaryButtonColour="error"
      open={open}
      title={t(
        'ui.event-management.practitioner-account.revoke-organisation.title',
      )}
      primaryButtonText={t(
        'ui.event-management.practitioner-account.revoke-organisation.confirm',
      )}
      secondaryButtonText={t(
        'ui.event-management.practitioner-account.revoke-organisation.deny',
      )}
      content={
        <>
          <TextV2 component="p">
            <Trans
              i18nKey="ui.event-management.practitioner-account.revoke-organisation.description"
              components={{
                bold: <TextV2 component="span" variant="bodyBold" />,
              }}
              values={{
                organisationText,
              }}
            />
          </TextV2>
          <Alert severity="error">
            {t(
              'ui.event-management.practitioner-account.revoke-organisation.alert',
            )}
          </Alert>
        </>
      }
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default RemoveOrganisationDialog;
